import type { WorkspaceEntityStore } from './registry';
import { workspaceRuntime } from '#layers/runtime/workspace/runtime';
import { createWorkspaceEntityHydrationDefiner } from './define-workspace-entity-hydration';

/**
 * Server entities that stores derive from: an rstore query hydrated into each candidate runtime's
 * entity cache and read from the active one. The definition owns the query; the seam owns only its
 * runtime lifetime (ADR 051).
 */
export const defineWorkspaceEntityHydration = createWorkspaceEntityHydrationDefiner<WorkspaceEntityStore>(workspaceRuntime);
